var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRendimiento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96.071,
    height: 87.496,
    viewBox: "0 0 96.071 87.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5017",
    "data-name": "Path 5017",
    d: "M278.737,124.921v3.715a8.908,8.908,0,0,0-8.138,6.455,7.655,7.655,0,0,0,1.042,6.011,9.1,9.1,0,0,0,5.99,3.9h0l6.337,1.189a4.033,4.033,0,0,1,2.675,1.677,2.627,2.627,0,0,1,.376,2.075c-.434,1.79-2.655,2.952-4.853,2.542l-7.676-1.439a2.528,2.528,0,1,0-.932,4.969l5.179.971v4.319a2.528,2.528,0,1,0,5.056,0V157.6a8.91,8.91,0,0,0,8.138-6.458,7.659,7.659,0,0,0-1.043-6.012,9.1,9.1,0,0,0-5.989-3.9l-6.338-1.189a4.032,4.032,0,0,1-2.675-1.677,2.629,2.629,0,0,1-.376-2.075c.435-1.79,2.661-2.95,4.853-2.542l7.675,1.439a2.528,2.528,0,1,0,.932-4.969l-5.179-.971v-4.32a2.528,2.528,0,0,0-5.056,0",
    transform: "translate(-270.381 -122.393)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -3.25,
    y1: 12.868,
    x2: -3.238,
    y2: 12.868,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59964a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cc14b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5018",
    "data-name": "Path 5018",
    d: "M534.793,305.139v8a2.528,2.528,0,0,0,5.056,0v-8a2.528,2.528,0,0,0-5.056,0",
    transform: "translate(-534.793 -302.611)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -28.501,
    y1: 37.13,
    x2: -28.448,
    y2: 37.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5019",
    "data-name": "Path 5019",
    d: "M439.572,211.045a2.528,2.528,0,0,0,2.148,2.859l6.023.857-21.24,15.63a11.159,11.159,0,0,1-6.637,2.171,10.567,10.567,0,0,1-2.193-.227,2.528,2.528,0,1,0-1.055,4.945h0a15.567,15.567,0,0,0,3.248.339,16.2,16.2,0,0,0,9.629-3.151l21.244-15.634-.975,6a2.528,2.528,0,1,0,4.992.81l1.966-12.114a2.528,2.528,0,0,0-2.14-2.908L442.431,208.9a2.553,2.553,0,0,0-.363-.026,2.525,2.525,0,0,0-2.5,2.173",
    transform: "translate(-414.616 -208.872)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.626,
    y1: 17.741,
    x2: -2.62,
    y2: 17.741,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5020",
    "data-name": "Path 5020",
    d: "M277.206,278.45a16.215,16.215,0,0,0-6.215,1.846l-26.728,14.259a2.529,2.529,0,0,0,1.192,4.759h0a2.514,2.514,0,0,0,1.188-.3l26.728-14.259a11.124,11.124,0,0,1,4.261-1.268,2.528,2.528,0,0,0-.222-5.047c-.067,0-.135,0-.2.008",
    transform: "translate(-242.924 -278.442)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1.736,
    y1: 23.536,
    x2: -1.729,
    y2: 23.536,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5021",
    "data-name": "Path 5021",
    d: "M322.247,365.99h0Zm-25.858-20.468V365.99h-9.725V350.36a2.528,2.528,0,0,0-5.057,0V365.99h-9.737V345.648a2.528,2.528,0,1,0-5.056,0V365.99h-9.725V352.354a2.528,2.528,0,0,0-5.057,0V365.99H242.3v-5.767a2.528,2.528,0,0,0-5.057,0v5.767h-6.008a2.528,2.528,0,1,0,0,5.056h91.014a2.528,2.528,0,1,0,0-5.056h-6.006V352.751a2.528,2.528,0,1,0-5.056,0V365.99h-9.738V345.522a2.528,2.528,0,0,0-5.057,0",
    transform: "translate(-228.705 -342.994)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.641,
    y1: 16.892,
    x2: -0.639,
    y2: 16.892,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5022",
    "data-name": "Path 5022",
    d: "M389.911,284.594a2.529,2.529,0,1,0,3.58,0,2.624,2.624,0,0,0-3.58,0",
    transform: "translate(-389.172 -283.889)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -20.737,
    y1: 97.507,
    x2: -20.684,
    y2: 97.507,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2157",
    "data-name": "Group 2157",
    transform: "translate(9596.779 -964.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2155",
    "data-name": "Group 2155",
    transform: "translate(-9596.779 964.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2099",
    "data-name": "Group 2099",
    transform: "translate(11.231)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_882",
    "data-name": "Rectangle 882",
    width: 22.334,
    height: 41.445,
    transform: "translate(-0.283 0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2101",
    "data-name": "Group 2101",
    transform: "translate(82.48 48.562)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_883",
    "data-name": "Rectangle 883",
    width: 5.056,
    height: 13.055,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2103",
    "data-name": "Group 2103",
    transform: "translate(50.096 23.303)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_884",
    "data-name": "Rectangle 884",
    width: 42.449,
    height: 28.747,
    transform: "translate(-0.235 0)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2105",
    "data-name": "Group 2105",
    transform: "translate(3.832 42.05)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_885",
    "data-name": "Rectangle 885",
    width: 37.49,
    height: 20.873,
    transform: "translate(-0.359 0)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2107",
    "data-name": "Group 2107",
    transform: "translate(0 59.444)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886",
    "data-name": "Rectangle 886",
    width: 96.071,
    height: 28.052,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2109",
    "data-name": "Group 2109",
    transform: "translate(43.241 43.518)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887",
    "data-name": "Rectangle 887",
    width: 5.057,
    height: 5.023,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2156",
    "data-name": "Group 2156",
    transform: "translate(-9596.779 964.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2099-2",
    "data-name": "Group 2099",
    transform: "translate(11.231)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_882-2",
    "data-name": "Rectangle 882",
    width: 22.334,
    height: 41.445,
    transform: "translate(-0.283 0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2101-2",
    "data-name": "Group 2101",
    transform: "translate(82.48 48.562)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_883-2",
    "data-name": "Rectangle 883",
    width: 5.056,
    height: 13.055,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2103-2",
    "data-name": "Group 2103",
    transform: "translate(50.096 23.303)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_884-2",
    "data-name": "Rectangle 884",
    width: 42.449,
    height: 28.747,
    transform: "translate(-0.235 0)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2105-2",
    "data-name": "Group 2105",
    transform: "translate(3.832 42.05)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_885-2",
    "data-name": "Rectangle 885",
    width: 37.49,
    height: 20.873,
    transform: "translate(-0.359 0)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2107-2",
    "data-name": "Group 2107",
    transform: "translate(0 59.444)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886-2",
    "data-name": "Rectangle 886",
    width: 96.071,
    height: 28.052,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2109-2",
    "data-name": "Group 2109",
    transform: "translate(43.241 43.518)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887-2",
    "data-name": "Rectangle 887",
    width: 5.057,
    height: 5.023,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRendimiento);
export default __webpack_public_path__ + "static/media/rendimiento.cb0d06ac19415ad1e2d01c00eebd6ebf.svg";
export { ForwardRef as ReactComponent };